export default __webpack_public_path__ + "static/media/wangye_app.956a23c1.png";